import { render, staticRenderFns } from "./RecipeImages.vue?vue&type=template&id=dc001816&scoped=true"
import script from "./RecipeImages.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeImages.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RecipeImages.vue?vue&type=style&index=0&id=dc001816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc001816",
  null
  
)

export default component.exports